import 'Bomdisoft/monitoring/browser';
import { delegateProductsCarousel } from 'Bomdisoft/app/[lang]/home/products-carousel/delegate';
import { delegateNotFoundPage } from 'Bomdisoft/app/[lang]/shared/not-found/render';
import { delegateProductsPage } from 'Bomdisoft/shared/products/delegate';
import { delegateAppGrid } from 'Bomdisoft/shared/top-bar/delegate';
import { toTopBarAuthOptions } from 'Bomdisoft/shared/top-bar/render';
import { delegateAuthControls } from '@bomdisoft/auth-bff/native';
import { defineLanguageOffer, registerServiceWorker, whenActivated } from '@bomdisoft/components/native';
import { getLanguageFromLocale } from '@bomdisoft/translations';
import { BOMDISOFT_LINKED_DOMAINS } from '@bomdisoft/utilities';

whenActivated(document, () => {
  const lang = document.documentElement.lang || 'en';

  const authSlot = document.querySelector<HTMLElement>('.bomdisoft-top-bar-right-group');
  if (authSlot !== null) delegateAuthControls(authSlot, toTopBarAuthOptions(lang), { oidc: true });

  delegateAppGrid(document);

  delegateProductsCarousel(document);

  delegateProductsPage(window, lang);

  delegateNotFoundPage(document, { browserLanguage: navigator.language, navigate: path => window.location.assign(path) });

  defineLanguageOffer(window);

  registerServiceWorker(window, { isProduction: process.env.NODE_ENV === 'production', language: getLanguageFromLocale(lang) });

  void import('Bomdisoft/frame/analytics').then(({ startAnalytics }) => startAnalytics({ apiKey: process.env.NEXT_PUBLIC_PRODANTIX_KEY ?? '', host: process.env.NEXT_PUBLIC_PRODANTIX_HOST ?? '', linkedDomains: BOMDISOFT_LINKED_DOMAINS, messengerHost: process.env.NEXT_PUBLIC_PRODANTIX_EDGE_HOST }));

  const mountAgentSurface = async () => {
    const [{ mountWebMcp, toLocationRouter }, { BOMDISOFT_ROUTES }] = await Promise.all([import('@bomdisoft/webmcp-ui/native'), import('Bomdisoft/lib/webmcp/routes')]);
    const root = document.createElement('div');
    document.body.append(root);
    mountWebMcp(root, { i18n: { locale: lang }, language: getLanguageFromLocale(lang), router: toLocationRouter(window), routes: BOMDISOFT_ROUTES });
  };

  if (typeof requestIdleCallback === 'function') requestIdleCallback(() => void mountAgentSurface());
  else setTimeout(() => void mountAgentSurface(), 2000);
});
